import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

export const PageHeader = ({ title, backTo = '/dashboard', actions }) => (
  <header className="glass-header sticky top-0 z-50 border-b border-[#27272A]">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Link to={backTo}>
          <Button variant="ghost" size="icon" className="text-[#A1A1AA] hover:text-white hover:bg-[#1A1A1A]" data-testid="back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
        </Link>
        <Flame className="w-8 h-8 text-[#E3000F]" />
        <h1 className="text-xl font-bold uppercase tracking-tighter" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          {title}
        </h1>
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  </header>
);
